// apolo/src/lib/loop/continueGuard.js — harness-uplift-r2 E6.
// @arch:pure-engine
//
// Amp `agent.end` 'continue' pattern with an explicit anti-loop MARKER guard:
// inject a follow-up message once (e.g. "run the relevant tests before finishing")
// and stamp a marker; if the marker is already in history, do NOT inject again —
// so the plugin can never loop forever. Pure; never throws.

export const CONTINUE_MARKER = '[auto-continue:e6]';

function historyHasMarker(history) {
  if (!Array.isArray(history)) return false;
  return history.some((m) => m && typeof m.content === 'string' && m.content.includes(CONTINUE_MARKER));
}

/**
 * @param {{ history?: Array<object>, followUp?: string }} p
 * @returns {{ action: 'continue'|'stop', message?: string }}
 */
export function decideContinue(p) {
  try {
    const followUp = p && typeof p.followUp === 'string' ? p.followUp.trim() : '';
    if (!followUp) return { action: 'stop' };
    if (historyHasMarker(p.history)) return { action: 'stop' }; // already fired once → no loop
    return { action: 'continue', message: `${CONTINUE_MARKER} ${followUp}` };
  } catch {
    return { action: 'stop' };
  }
}
